// Haptic feedback utility for mobile devices
export const haptics = {
  // Light tap feedback
  light: () => {
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate(10)
    }
  },

  // Medium tap feedback
  medium: () => {
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate(20)
    }
  },

  // Heavy tap feedback
  heavy: () => {
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate(50)
    }
  },

  // Success feedback
  success: () => {
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate([10, 50, 10])
    }
  },

  // Error feedback
  error: () => {
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate([50, 50, 50])
    }
  },

  // Selection feedback
  selection: () => {
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate(5)
    }
  }
}

// Hook for easy use in components
export const useHaptics = () => {
  return haptics
}
